@let weather = farmStore.weather();

<div class="d-flex gap-3 color-primary-information">
    <div>
        <i class="fa-solid fa-temperature-quarter"></i>
        {{ weather?.current?.temperature_2m ?? '?'}}{{ weather?.current_units?.temperature_2m }}
    </div>
    <div>
        <i class="fa-solid fa-wind"></i>
        {{ weather?.current?.wind_speed_10m ?? '?'}}{{ weather?.current_units?.wind_speed_10m }}
    </div>
    <div>
        <i class="fa-solid fa-droplet"></i>
        {{ weather?.current?.relative_humidity_2m ?? '?'}}{{ weather?.current_units?.relative_humidity_2m }}
    </div>
</div>
